import NavContext from '@/context/nav.context';
import useApplicationConfig from '@/hooks/useApplicationConfig';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { useAppShellController } from './app-shell.controller';
import ShellHeader from './components/header/shell-header.component';
import SidebarContent from './components/sidebar/sidebar-content.component';

interface IAppShellProps {}

/**
 * This component can only be used under the /home path.
 * Otherwise it might trigger an error
 */
export default function AppShell(props: PropsWithChildren<IAppShellProps>) {
	const { links, isOpen, handleClose, handleToggle, ref } = useAppShellController();
	const config = useApplicationConfig();

	return (
		<NavContext.Provider value={{ ref }}>
			<Box
				borderTopColor="gray.200"
				borderTopWidth={0.5}
				display="grid"
				gridTemplateColumns={{ base: '1fr', lg: config.hideSidebar ? '1fr' : isOpen ? '327px 1fr' : '0px 1fr' }}
				h="100dvh"
				overflow="hidden"
				transition="all .4s"
				w="100dvw"
				willChange="all"
			>
				{config.hideSidebar ? null : <SidebarContent isOpen={isOpen} links={links} onClose={handleClose} />}
				<Box as="main" data-id="content" h="100%" w="100%" overflow="hidden" display="grid" gridTemplateRows="auto 1fr">
					<ShellHeader isSidebarOpen={isOpen} onToggle={handleToggle} />
					<Box as="article" w="full" h="full" overflow="auto" pl="xs">
						{props.children}
					</Box>
				</Box>
			</Box>
		</NavContext.Provider>
	);
}
